import { createFileRoute } from '@tanstack/react-router'
import { CreateTicketForm } from '@/features/ticket-create/CreateTicketForm'

export const Route = createFileRoute('/tickets/new')({ component: CreateTicketForm })
